import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { AdService } from "../../ad-service";
// eslint-disable-next-line react/display-name
const AdSlotRow = ({ metadata = {} }) => {
  const adLayout = get(metadata, ["layout"], "Leaderboard");
  const { targetingId: adTargetingId, customCode } = get(metadata, ["config"], {});
  return (
    <div className="component-wrapper">
      <AdService row adtype={adLayout} customCode={customCode} adTargetingId={adTargetingId} layoutName="PageBuilder" />
    </div>
  );
};
AdSlotRow.propTypes = {
  metadata: PropTypes.object
};

export { AdSlotRow };
